import { FailureScreenProps } from "shared/games/types/GameConfiguration";
import { GameQuestionIsThisCompressorOn } from "shared/games/types/GameQuestions";
import { GameAnswerIsThisCompressorOn } from "shared/games/types/GameAnswers";
import * as GameLayout from "ui/templates/Game/LayoutComponents";
import Button from "ui/atoms/Button/Button";
import ABPicker from "ui/organisms/ABPicker/ABPicker";

type Props = FailureScreenProps<
  GameQuestionIsThisCompressorOn,
  GameAnswerIsThisCompressorOn
>;

export default function IsThisCompOnFailedScreen({
  onNext,
  question,
  mobileToolbarStyle,
}: Props) {
  return (
    <>
      <GameLayout.Toolbar mobileStyle={mobileToolbarStyle}>
        <div className={"flex justify-between"}>
          <div className={"mr-2"} />

          <Button theme="green" size="large" onClick={onNext}>
            Next
          </Button>
        </div>
      </GameLayout.Toolbar>

      <GameLayout.Container>
        <div
          className={
            "flex items-center justify-center overflow-hidden p-24 md:p-32"
          }
        >
          <ABPicker
            onClick={noop}
            questionText={"Is more compressed?"}
            answer={question.answer}
            answerText="Was the most compressed"
          />
        </div>
      </GameLayout.Container>
    </>
  );
}

const noop = () => {};
